import ChangePasswordBoilerplate from "@mirage/components/changePassword/ChangePasswordBoilerplate";
import BigLogo from "@publicPortal/components/bigLogo/BigLogo";
import Board from "@publicPortal/components/board/Board";
import ResultBoard from "@publicPortal/components/resultBoard/ResultBoard";
import { PublicPortalRoutingService } from "@publicPortal/services/PublicPortalRoutingService";
import { UserService } from "@publicPortal/services/UserService";
import { memo, useState } from "react";

const userService = new UserService();
const publicPortalRouting = new PublicPortalRoutingService();

const ChangePassword = memo(() => {
    const [resultBoard, setResultBoard] = useState({ show: false, message: "", success: true, isLoading: false });

    return (
        <>
            <BigLogo />
            {resultBoard.show ? (
                <ResultBoard
                    success={resultBoard.success}
                    loading={false}
                    headerText="Change password"
                    buttonLabel="Back"
                    buttonNavTo={publicPortalRouting.UserSettingsRoute()}
                    message={resultBoard.message}
                />
            ) : (
                <Board headerText="Change password" size="small">
                    <ChangePasswordBoilerplate service={userService} backButtonRoute={publicPortalRouting.UserSettingsRoute()} setResultBoard={setResultBoard} />
                </Board>
            )}
        </>
    );
});

export default ChangePassword;
